import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, message } from 'antd';
import DashboardLayout from '../components/DashboardLayout';
import { useWriteContract } from 'wagmi';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contractConfig';

const InviteCode: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectDetails, setProjectDetails] = useState<any>(null);
  const { writeContractAsync, isSuccess, isError, isPending } = useWriteContract();

  // Extract query params
  const params = new URLSearchParams(location.search);
  const projectId = params.get('projectid');  // Fetch projectId from the query params

  useEffect(() => {
    if (projectId) {
      // Fetch project details based on the projectId (Placeholder data for now)
      setProjectDetails({
        title: 'Project Title',
        description: 'Project description goes here...',
        imageUrl: 'https://via.placeholder.com/300',
        iconUrl: 'https://via.placeholder.com/50',
      });
    } else {
      // Redirect to the dashboard if projectId is missing
      message.error('Invalid promotion link. Redirecting to dashboard...');
      navigate('/dashboard');
    }
  }, [projectId]);

  const handleGenerateInviteCode = async () => {
    if (!projectId) return;

    try {
      const tx = await writeContractAsync({
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'createInviteCode',
        args: [projectId],  // Use the projectId to generate the invite code
      });

      if (isPending) {
        console.log('Generating invite code pending:', isPending);
      }

      if (isError) {
        console.log('Generating invite code failed:', isError);
      }

      if (isSuccess) {
        console.log('Invite code successfully generated:', isSuccess);
      }

      message.success('Invite code generated successfully!');
      // You can store the invite code here or display it as needed
    } catch (error) {
      message.error('Failed to generate invite code. Please try again.');
    }
  };

  return (
    <DashboardLayout>
      <div style={{ padding: '2rem' }}>
        <Card
          title={projectDetails ? projectDetails.title : 'Loading...'}
          bordered={false}
          style={{ width: '100%' }}
        >
          {projectDetails && (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={projectDetails.imageUrl}
                  alt="Project Image"
                  style={{ width: '300px', height: 'auto', marginBottom: '20px' }}
                />
              </div>
              <h3>Description:</h3>
              <p>{projectDetails.description}</p>
              <h4>Project Icon:</h4>
              <img
                src={projectDetails.iconUrl}
                alt="Project Icon"
                style={{ width: '50px', height: '50px', marginTop: '10px' }}
              />
              <Button
                type="primary"
                onClick={handleGenerateInviteCode}
                style={{ marginTop: '20px' }}
                loading={isPending}
              >
                Generate Invite Code
              </Button>
            </>
          )}
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default InviteCode;
